import { useSessionStore } from "@/stores/session";

export default defineNuxtRouteMiddleware((to, from) => {
  const sessionStore = useSessionStore();

  if (sessionStore.lead_id !== null && to.path !== '/report') {
    return navigateTo('/report')
  }
})
